module.exports = __webpack_public_path__ + "img/shiba888-ic-mobile-left-1.5d29fd2e.png";